// extracted by mini-css-extract-plugin
export default {"nonProFooter":"modal_non_pro_footer__nonProFooter--oxOM","lockIcon":"modal_non_pro_footer__lockIcon--qHEH"};